<template>
  <ProductDisplay
    v-if="posts.length > 0"
    title="How you're wearing it"
    sub-title="Tag us @ratandboa and use the hashtag #rat&boa for a chance to be featured"
    color="grey"
  >
    <Carousel>
      <div v-for="post in posts" :key="post.id" ref="slides" class="slide">
        <div class="media">
          <img
            v-if="post.type === 'IMAGE'"
            :src="post.url"
            class="image"
            :alt="post.caption"
          />

          <Video
            v-if="post.type === 'VIDEO'"
            :video="{
              sources: [
                {
                  url: post.url,
                },
              ],
            }"
          >
          </Video>
        </div>

        <div class="info">
          <span class="info__likes">{{ post.like_count }} likes</span>
          <p class="info__caption">{{ post.caption }}</p>
        </div>
      </div>
    </Carousel>
  </ProductDisplay>
</template>

<script>
import Carousel from "@/components/Carousel.vue";
import Video from "@/components/Video.vue";
import ProductDisplay from "@/components/product-display/ProductDisplay.vue";
import { mapState } from "vuex";

export default {
  name: "HowToWear",
  components: {
    Video,
    Carousel,
    ProductDisplay,
  },
  data() {
    return {
      posts: [],
    };
  },
  computed: {
    ...mapState("product", ["product"]),
  },
  async mounted() {
    await this.fetchPosts();
  },
  methods: {
    async fetchPosts() {
      try {
        const splitProductId = this.product.id.split(
          "gid://shopify/Product/"
        )[1];
        const url = `${process.env.HOW_TO_WEAR_GADGET_URL}/productid/${splitProductId}`;

        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const json = await response.json();

        const posts = json.map(({ post }) => ({
          id: post.id,
          caption: post.caption,
          like_count: post.likeCount,
          type: post.mediaType,
          url: post.media.url,
        }));

        this.posts = posts;
      } catch (error) {
        console.error("There was an error fetching the posts:", error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.slide {
  .info {
    @include utility-body(14px);

    &__likes {
      display: block;
      margin-bottom: 4px;
    }

    &__caption {
      color: $color-grey-dark;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
      overflow: hidden;

      * {
        display: inline;
      }
    }
  }

  .image,
  :deep(.video-intersection-observer),
  :deep(.video__element) {
    display: block;
    aspect-ratio: 4/5;
    object-fit: cover;
    max-width: 100%;
    margin-bottom: 12px;
  }
}
</style>
